const grade_12= {
    label: "Grade 12",
    subjects: {
"applied_design_12": {
   "label": "Applied Design (Grade 12)",
    "topics": [
      { "value": "Understanding_Context", "label": "Understanding Context" },
      { "value": "defining", "label": "Defining" },
      { "value": "ideating", "label": "Ideating" },
      { "value": "prototyping", "label": "Prototyping" },
      { "value": "testing", "label": "Testing" },
      { "value": "making", "label": "Making" },
      { "value": "sharing", "label": "Sharing" },
      { "value": "applied_skills", "label": "Applied Skills" },
      { "value": "applied_technologies", "label": "Applied Technologies" }
    ],
    "competencies": {
      "core": [
      { "value": "Understanding_Context", "label": "Understanding Context" },
      { "value": "defining", "label": "Defining" },
      { "value": "ideating", "label": "Ideating" },
      { "value": "prototyping", "label": "Prototyping" },
      { "value": "testing", "label": "Testing" },
      { "value": "making", "label": "Making" },
      { "value": "sharing", "label": "Sharing" },
      { "value": "applied_skills", "label": "Applied Skills" },
      { "value": "applied_technologies", "label": "Applied Technologies" }
      ],
    "sub": {
        "applied_design": [
          /* -------------------- Defining -------------------- */
          {
            "value": "research_empathy_observation",
            "label": "Engage in a period of research and empathetic observation to understand design opportunities"
          },
          {
            "value": "choose_design_opportunity",
            "label": "Choose a design opportunity"
          },
          {
            "value": "identify_users_context",
            "label": "Identify potential users and relevant contextual factors"
          },
          {
            "value": "identify_criteria_intended_impact_constraints",
            "label": "Identify criteria for success, intended impact, and any constraints"
          },

          /* -------------------- Ideating -------------------- */
          {
            "value": "take_creative_risks",
            "label": "Take creative risks in generating ideas and add to others’ ideas in ways that enhance them"
          },
          {
            "value": "screen_ideas_criteria_constraints",
            "label": "Screen ideas against criteria and constraints"
          },
          {
            "value": "analyze_prioritize_factors",
            "label": "Critically analyze and prioritize competing factors, including social, ethical, and sustainability considerations, to meet community needs for preferred futures"
          },
          {
            "value": "choose_idea_keep_alternatives",
            "label": "Choose an idea to pursue, keeping other potentially viable ideas open"
          },
          {
            "value": "identify_use_inspiration_sources",
            "label": "Identify and use sources of inspiration and information"
          },

          /* -------------------- Prototyping -------------------- */
          {
            "value": "choose_form_plan_prototyping",
            "label": "Choose a form for prototyping and develop a plan that includes key stages and resources"
          },
          {
            "value": "evaluate_materials_reuse",
            "label": "Evaluate a variety of materials for effective use and potential for reuse, recycling, and biodegradability"
          },
          {
            "value": "prototype_make_changes",
            "label": "Prototype, making changes to tools, materials, and procedures as needed"
          },
          {
            "value": "record_iterations",
            "label": "Record iterations of prototyping"
          },

          /* -------------------- Testing -------------------- */
          {
            "value": "identify_feedback_sources",
            "label": "Identify sources of feedback"
          },
          {
            "value": "develop_test_prototype",
            "label": "Develop an appropriate test of the prototype"
          },
          {
            "value": "conduct_test_collect_data",
            "label": "Conduct the test, collect and compile data, evaluate data, and decide on changes"
          },
          {
            "value": "iterate_or_abandon",
            "label": "Iterate the prototype or abandon the design idea"
          },

          /* -------------------- Making -------------------- */
          {
            "value": "identify_use_production_tools",
            "label": "Identify and use appropriate tools, technologies, materials, and processes for production"
          },
          {
            "value": "make_production_plan",
            "label": "Make a step-by-step plan for production and carry it out, making changes as needed"
          },
          {
            "value": "minimize_waste",
            "label": "Use materials in ways that minimize waste"
          },

          /* -------------------- Sharing -------------------- */
          {
            "value": "decide_sharing",
            "label": "Decide on how and with whom to share their product and processes"
          },
          {
            "value": "demonstrate_product_rationale",
            "label": "Demonstrate their product to potential users, providing rationale for the selected solution, modifications, and procedures"
          },
          {
            "value": "critically_evaluate_success",
            "label": "Critically evaluate the success of their product and explain how their design ideas contribute to the individual, family, community, and/or environment"
          },
          {
            "value": "critically_reflect_design_process",
            "label": "Critically reflect on their design thinking and processes, and evaluate their ability to work effectively both as individuals and collaboratively in a group, including maintaining a co-operative workspace"
          },
          {
            "value": "identify_new_design_issues",
            "label": "Identify new design issues"
          }
        ],

        /* -------------------- Applied Skills -------------------- */
        "applied_skills": [
          {
            "value": "awareness_safety_procedures",
            "label": "Demonstrate an awareness of precautionary and emergency safety procedures in both physical and digital environments"
          },
          {
            "value": "identify_refine_skills",
            "label": "Identify the skills and skill levels needed, individually or as a group, in relation to specific projects, and develop and refine them as needed"
          }
        ],

        /* -------------------- Applied Technologies -------------------- */
        "applied_technologies": [
          {
            "value": "choose_adapt_learn_technologies",
            "label": "Choose, adapt, and if necessary, learn about appropriate tools and technologies to use for tasks"
          },
          {
            "value": "evaluate_technology_impacts",
            "label": "Evaluate the personal, social, and environmental impacts, including unintended negative consequences, of the choices they make about technology use"
          },
          {
            "value": "evaluate_land_resource_culture_influence",
            "label": "Evaluate how the land, natural resources, and culture influence the development and use of tools and technologies"
          }
        ]
      }
    }
  },
          "arts_12": {
    "label": "Arts Education (Grade 12)",
    topics: [
        { value: "Explore and Create", label: "Explore and Create" },
        { value: "reasoning_reflecting", label: "Reason and Reflect" },
        { value: "communicating_documenting", label: "Communicate and Document" },
        { value: "connecting_expanding", label: "Connect & Expand" }
      ],
      competencies: {
        core: [
          { value: "Exploring", label: "Explore and Create" },
          { value: "Reasoning", label: "Reason and Reflect" },
          { value: "Communicating", label: "Communicate and Document" },
          { value: "Connecting", label: "Connect & Expand" }
        ],

      "sub": {
        "exploring_creating": [
          {
            "value": "select_apply_elements_grade8",
            "label": "Intentionally select and apply materials, movements, technologies, environments, tools, and techniques by combining and arranging artistic elements, processes, and principles in art making"
          },
          {
            "value": "create_artistic_works_grade8",
            "label": "Create artistic works collaboratively and as an individual using ideas inspired by imagination, inquiry, experimentation, and purposeful play"
          },
          {
            "value": "explore_identity_place_culture_society_grade8",
            "label": "Explore relationships between identity, place, culture, society, and belonging through arts activities and experiences"
          }
        ],

        "reasoning_reflecting": [
          {
            "value": "describe_evaluate_artists_grade8",
            "label": "Describe, interpret, and evaluate how artists use processes, materials, movements, technologies, tools, techniques, and environments to create and communicate ideas"
          },
          {
            "value": "develop_refine_critique_grade8",
            "label": "Develop and refine ideas, and critically appraise ideas, processes, and technical skills in a variety of art forms to improve the quality of artistic creations"
          },
          {
            "value": "reflect_understand_motivations_grade8",
            "label": "Reflect on works of art and creative processes to understand artists’ motivations and meanings"
          },
          {
            "value": "understand_appreciate_contexts_grade8",
            "label": "Demonstrate an understanding and appreciation of personal, social, cultural, historical, and environmental contexts in relation to the arts"
          },
          {
            "value": "interpret_using_other_learning_grade8",
            "label": "Interpret works of art using knowledge and skills from various areas of learning"
          }
        ],

        "communicating_documenting": [
          {
            "value": "interpret_communicate_symbols_grade8",
            "label": "Interpret and communicate ideas using symbols and elements to express meaning through the arts"
          },
          {
            "value": "take_creative_risks_grade8",
            "label": "Take creative risks to express feelings, ideas, and experiences"
          },
          {
            "value": "describe_interpret_respond_art_grade8",
            "label": "Describe, interpret, and respond to works of art"
          },
          {
            "value": "experience_document_perform_share_grade8",
            "label": "Experience, document, choreograph, perform, and share creative works in a variety of ways"
          }
        ],

        "connecting_expanding": [
          {
            "value": "respond_using_world_knowledge_grade8",
            "label": "Respond to works of art using one’s knowledge of the world"
          },
          {
            "value": "use_arts_global_environmental_grade8",
            "label": "Use the arts to communicate, respond to, and understand environmental and global issues"
          },
          {
            "value": "demonstrate_sophisticated_application_grade8",
            "label": "Demonstrate increasingly sophisticated application and/or engagement of curricular content"
          }
        ]
      }
    }
  },
   career_education_12_life: {
        label: 'Career Education (Career-Life Education) (Grade 10)',
        topics: [],
        competencies: {
          core: [
            { value: 'examine', label: 'Examine' },
            { value: 'interact', label: 'Interact' },
            { value: 'experience', label: 'Experience' },
            { value: 'initiate', label: 'Initiate' },
            // { value: 'share', label: 'Share' }
          ],
          sub: {
            examine: [
              { value: 'use_self_assessment_and_reflection', label: 'Use self-assessment and reflection to develop awareness of their strengths, preferences, and skills' },
              { value: 'recognize_the_impact_of_personal_public_identity', label: 'Recognize the impact of personal public identity in the world of work' },
              { value: 'question_self_and_others_about_how_individual_purposes', label: 'Question self and others about how individual purposes and passions can support the needs of the local and global community when considering career choices' }
            ],
            interact: [
              { value: 'demonstrate_respect_collaboration_and_inclusivity', label: 'Demonstrate respect, collaboration, and inclusivity in working with others to solve problems' },
              { value: 'question_self_and_others_about_the_role_of_family_expectations', label: 'Question self and others about the role of family expectations and traditions, and of community needs in career choices' }
            ],
            experience: [
              { value: 'explore_volunteer_and_other_new_learning_experiences', label: 'Explore volunteer and other new learning experiences that stimulate entrepreneurial and innovative thinking' },
              { value: 'apply_decision_making_strategies', label: 'Apply decision-making strategies to a life, work, or community problem and adjust the strategies to adapt to new situations' }
            ],
            initiate: [
              { value: 'recognize_the_influence_of_curriculum_choices', label: 'Recognize the influence of curriculum choices and co-curricular activities on career paths' },
              { value: 'set_and_achieve_realistic_learning_goals', label: 'Set and achieve realistic learning goals with perseverance and resilience' },
              { value: 'apply_a_variety_of_research_skills', label: 'Apply a variety of research skills to expand their knowledge of diverse career possibilities and understand career clusters' }
            ],
            share: [
              { value: 'demonstrate_safety_skills_and_appreciate_the_importance_of_workplace_safety', label: 'Demonstrate safety skills and appreciate the importance of workplace safety' },
              { value: 'appreciate_the_value_of_a_network_of_resources', label: 'Appreciate the value of a network of resources and mentors to assist with career exploration' },
              { value: 'recognize_and_explore_diverse_perspectives', label: 'Recognize and explore diverse perspectives on how work contributes to our community and society' }
            ]
          }
        }
      },
    career_education_12_Connections: {
        label: 'Career Education (Career-life Connections) (Grade12)',
        topics: [],
        competencies: {
          core: [
            { value: 'examine', label: 'Examine' },
            { value: 'interact', label: 'Interact' },
            { value: 'experience', label: 'Experience' },
            // { value: 'initiate', label: 'Initiate' },
            { value: 'share', label: 'Share' }
          ],
          sub: {
            examine: [
              { value: 'use_self_assessment_and_reflection', label: 'Use self-assessment and reflection to develop awareness of their strengths, preferences, and skills' },
              { value: 'recognize_the_impact_of_personal_public_identity', label: 'Recognize the impact of personal public identity in the world of work' },
              { value: 'question_self_and_others_about_how_individual_purposes', label: 'Question self and others about how individual purposes and passions can support the needs of the local and global community when considering career choices' }
            ],
            interact: [
              { value: 'demonstrate_respect_collaboration_and_inclusivity', label: 'Demonstrate respect, collaboration, and inclusivity in working with others to solve problems' },
              { value: 'question_self_and_others_about_the_role_of_family_expectations', label: 'Question self and others about the role of family expectations and traditions, and of community needs in career choices' }
            ],
            experience: [
              { value: 'explore_volunteer_and_other_new_learning_experiences', label: 'Explore volunteer and other new learning experiences that stimulate entrepreneurial and innovative thinking' },
              { value: 'apply_decision_making_strategies', label: 'Apply decision-making strategies to a life, work, or community problem and adjust the strategies to adapt to new situations' }
            ],
            initiate: [
              { value: 'recognize_the_influence_of_curriculum_choices', label: 'Recognize the influence of curriculum choices and co-curricular activities on career paths' },
              { value: 'set_and_achieve_realistic_learning_goals', label: 'Set and achieve realistic learning goals with perseverance and resilience' },
              { value: 'apply_a_variety_of_research_skills', label: 'Apply a variety of research skills to expand their knowledge of diverse career possibilities and understand career clusters' }
            ],
            share: [
              { value: 'demonstrate_safety_skills_and_appreciate_the_importance_of_workplace_safety', label: 'Demonstrate safety skills and appreciate the importance of workplace safety' },
              { value: 'appreciate_the_value_of_a_network_of_resources', label: 'Appreciate the value of a network of resources and mentors to assist with career exploration' },
              { value: 'recognize_and_explore_diverse_perspectives', label: 'Recognize and explore diverse perspectives on how work contributes to our community and society' }
            ]
          }
        }
      },
  
     
"english_12": {
    "label": "English Language Arts (Grade 12)",
    "topics": [
      { "value": "comprehend_connect", "label": "Comprehend and Connect (Reading, Listening, Viewing)" },
      { "value": "create_communicate", "label": "Create and Communicate (Writing, Speaking, Representing)" }
    ],
    "competencies": {
      "core": [
        { "value": "comprehend_connect", "label": "Comprehend and Connect" },
        { "value": "create_communicate", "label": "Create and Communicate" }
      ],
      "sub": {
        "comprehend_connect": [
          {
            "value": "access_info_evaluate",
            "label": "Access information and ideas for diverse purposes from a variety of sources and evaluate their relevance, accuracy, and reliability (Grade 6–9)"
          },
          {
            "value": "apply_strategies_comprehend",
            "label": "Apply appropriate strategies to comprehend written, oral, and visual texts, guide inquiry, and extend thinking (Grade 6–9)"
          },
          {
            "value": "synthesize_ideas_sources",
            "label": "Synthesize ideas from a variety of sources to build understanding (Grade 5–9)"
          },
          {
            "value": "recognize_text_features_genres",
            "label": "Recognize and appreciate how different features, forms, and genres of texts reflect different purposes, audiences, and messages (Grade 6–9)"
          },
          {
            "value": "think_critically_creatively",
            "label": "Think critically, creatively, and reflectively to explore ideas within, between, and beyond texts (Grade 6–9)"
          },
          {
            "value": "identify_personal_social_cultural_context",
            "label": "Recognize and identify the role of personal, social, and cultural contexts, values, and perspectives in texts (Grade 6–9)"
          },
          {
            "value": "recognize_language_identity",
            "label": "Recognize how language constructs personal, social, and cultural identity (Grade 6–9)"
          },
          {
            "value": "construct_personal_connections",
            "label": "Construct meaningful personal connections between self, text, and world (Grade 6–9)"
          },
          {
            "value": "respond_text_personal_creative_critical",
            "label": "Respond to text in personal, creative, and critical ways (Grade 6–9)"
          },
          {
            "value": "explain_literary_elements_devices",
            "label": "Understand or explain how literary elements, techniques, and devices enhance and shape meaning (Grade 6–9)"
          },
          {
            "value": "recognize_text_structures",
            "label": "Recognize an increasing range of text structures and how they contribute to meaning (Grade 6–9)"
          },
          {
            "value": "appreciate_fp_story_role",
            "label": "Recognize and appreciate the role of story, narrative, and oral tradition in expressing First Peoples perspectives, values, beliefs, and points of view (Grade 6–9)"
          },
          {
            "value": "fp_protocols_ownership",
            "label": "Develop an awareness of the protocols, ownership, and diversity within and across First Peoples texts (Grade 8–9)"
          },
          {
            "value": "influence_of_place_texts",
            "label": "Recognize the influence of place in First Peoples and other Canadian texts (Grade 6–9)"
          }
        ],

        "create_communicate": [
          {
            "value": "exchange_ideas_viewpoints",
            "label": "Exchange ideas and viewpoints to build shared understanding and extend thinking (Grade 6–9)"
          },
          {
            "value": "writing_design_processes_6_9",
            "label": "Use writing and design processes to plan, develop, and create engaging and meaningful literary and informational texts for a variety of purposes and audiences (Grade 6–9)"
          },
          {
            "value": "assess_refine_texts",
            "label": "Assess and refine texts to improve their clarity, effectiveness, and impact according to purpose, audience, and message (Grade 6–9)"
          },
          {
            "value": "use_canadian_conventions",
            "label": "Use an increasing repertoire of conventions of Canadian spelling, grammar, and punctuation (Grade 6–9)"
          },
          {
            "value": "oral_storytelling_processes",
            "label": "Use and experiment with oral storytelling processes (Grade 6–9)"
          },
          {
            "value": "select_features_forms_genres",
            "label": "Select and use appropriate features, forms, and genres according to audience, purpose, and message (Grade 6–9)"
          },
          {
            "value": "transform_ideas_original_texts",
            "label": "Transform ideas and information to create original texts (Grade 4–9)"
          },
          {
            "value": "express_opinion_support_evidence",
            "label": "Express an opinion and support it with credible evidence (Grade 9 emphasis)"
          }
        ]
      }
    }
  },
     
  "math_12": {
  "label": "Mathematics (Grade 12)",
"topics": [
      { "value": "reasoning_analyzing", "label": "Reasoning and Modeling" },
      { "value": "understanding_solving", "label": "Understanding and Solving" },
      { "value": "communicating_representing", "label": "Communicating and Representing" },
      { "value": "connecting_reflecting", "label": "Connecting and Reflecting" }
    ],

    "competencies": {
      "core": [
        { "value": "reasoning_analyzing", "label": "Reasoning and Modeling" },
        { "value": "understanding_solving", "label": "Understanding and Solving" },
        { "value": "communicating_representing", "label": "Communicating and Representing" },
        { "value": "connecting_reflecting", "label": "Connecting and Reflecting" }
      ],
      "sub": {
        "reasoning_analyzing": [
          {
            "value": "use_logic_patterns_solve_puzzles_6_9",
            "label": "Use logic and patterns to solve puzzles and play games"
          },
          {
            "value": "reason_analyze_apply_math_ideas_6_9",
            "label": "Use reasoning and logic to explore, analyze, and apply mathematical ideas"
          },
          {
            "value": "estimate_reasonably_6_9",
            "label": "Estimate reasonably"
          },
          {
            "value": "mental_math_strategies_6_9",
            "label": "Demonstrate and apply mental math strategies"
          },
          {
            "value": "use_tools_technology_patterns_6_9",
            "label": "Use tools or technology to explore and create patterns and relationships, and test conjectures"
          }
        ],

        "understanding_solving": [
          {
            "value": "model_mathematics_context_6_9",
            "label": "Model mathematics in contextualized experiences"
          },
          {
            "value": "apply_multiple_problem_solving_strategies_6_9",
            "label": "Apply multiple strategies to solve problems in both abstract and contextualized situations"
          },
          {
            "value": "demonstrate_math_understanding_6_9",
            "label": "Develop, demonstrate, and apply mathematical understanding through play, inquiry, and problem solving"
          },
          {
            "value": "visualize_explore_math_concepts_6_9",
            "label": "Visualize to explore mathematical concepts"
          },
          {
            "value": "problem_solving_local_culture_6_9",
            "label": "Engage in problem-solving experiences connected to place, story, cultural practices, and perspectives relevant to local First Peoples communities, the local community, and other cultures"
          }
        ],

        "communicating_representing": [
          {
            "value": "use_math_vocabulary_discussions_6_9",
            "label": "Use mathematical vocabulary and language to contribute to mathematical discussions"
          },
          {
            "value": "explain_justify_math_ideas_6_9",
            "label": "Explain and justify mathematical ideas and decisions"
          },
          {
            "value": "communicate_math_thinking_6_9",
            "label": "Communicate mathematical thinking in many ways"
          },
          {
            "value": "represent_math_ideas_6_9",
            "label": "Represent mathematical ideas in concrete, pictorial, and symbolic forms"
          }
        ],

        "connecting_reflecting": [
          {
            "value": "reflect_math_thinking_6_9",
            "label": "Reflect on mathematical thinking"
          },
          {
            "value": "connect_math_concepts_6_9",
            "label": "Connect mathematical concepts to each other and to other areas and personal interests"
          },
          {
            "value": "use_math_arguments_support_choices_6_9",
            "label": "Use mathematical arguments to support personal choices"
          },
          {
            "value": "incorporate_first_peoples_perspectives_6_9",
            "label": "Incorporate First Peoples worldviews and perspectives to make connections to mathematical concepts"
          }
        ]
      }
    }
  }
,

 "phe_12_active": {
    "label": "Physical and Health Education (Active Living 12 )",
  "topics": [
      { "value": "Health_Well_being", "label": "Health & Well-being" },
      { "value": "Safety", "label": "Safety" },
      { "value": "Participation", "label": "Participation" },
      { "value": "Leadership", "label": "Leadership" }
    ],

    "competencies": {
      "core": [
        { "value": "Health_Well_being", "label": "Health & Well-being" },
      { "value": "Safety", "label": "Safety" },
      { "value": "Participation", "label": "Participation" },
      { "value": "Leadership", "label": "Leadership" }
      ],


      "sub": {
        "physical_literacy": [
          {
            "value": "refine_apply_movement_skills_10",
            "label": "Refine and apply movement skills in a variety of physical activities and environments (10–12)"
          },
          {
            "value": "apply_movement_concepts_strategies_10",
            "label": "Apply movement concepts and strategies in different physical activities (10–12)"
          },
          {
            "value": "safety_fair_play_leadership_10",
            "label": "Develop and demonstrate safety, fair play, and leadership in physical activities (10–12)"
          },
          {
            "value": "personal_fitness_goals_10",
            "label": "Analyze and apply strategies for developing and maintaining personal fitness goals"
          },
          {
            "value": "relationship_physical_health_10",
            "label": "Explain the relationship between physical activity, health, and well-being"
          }
        ],

        "healthy_active_living": [
          {
            "value": "daily_physical_activity_10",
            "label": "Participate daily in physical activity designed to improve and maintain personal fitness and well-being"
          },
          {
            "value": "healthy_living_goals_10",
            "label": "Identify, apply, and reflect on strategies for developing healthy-living goals"
          },
          {
            "value": "factors_influencing_health_10",
            "label": "Evaluate and explain factors that influence personal health decisions"
          },
          {
            "value": "media_technology_peer_influence_10",
            "label": "Analyze influences of media, technology, and peers on health decisions"
          },
          {
            "value": "healthy_sexual_decision_making_10",
            "label": "Analyze strategies for promoting healthy sexual decision-making"
          },
          {
            "value": "healthy_relationships_10",
            "label": "Identify and apply strategies for developing and maintaining healthy relationships"
          }
        ],

        "social_community_health": [
          {
            "value": "respond_discrimination_bullying_10",
            "label": "Describe and assess strategies for responding to discrimination, stereotyping, and bullying (10–12)"
          },
          {
            "value": "promote_social_community_health_10",
            "label": "Describe strategies for promoting positive social and community health"
          },
          {
            "value": "respond_unsafe_situations_10",
            "label": "Analyze strategies for responding to unsafe situations, including potential violence and substance use"
          }
        ],

        "mental_well_being": [
          {
            "value": "manage_stress_mental_wellbeing_10",
            "label": "Apply strategies for managing stress and promoting mental well-being"
          },
          {
            "value": "manage_problems_mental_wellbeing_substance_10",
            "label": "Analyze strategies for managing problems related to mental well-being and substance use"
          },
          {
            "value": "influences_on_identity_10",
            "label": "Explain influences on identity, including sexual identity, gender, and culture"
          },
          {
            "value": "factors_influencing_mental_wellbeing_10",
            "label": "Analyze factors that influence mental well-being and decision-making"
          },
          {
            "value": "adapt_to_life_changes_10",
            "label": "Develop strategies for adapting to life changes and transitions"
          }
        ]
      }
    }
  },
    
  "phe_12_Fitness": {
    "label": "Physical and Health Education (Fitness & Conditioning 12 )",
  "topics": [
      { "value": "Healthy_Active_Living", "label": "Healthy & Active Living" },
      { "value": "Human_Anatomy_Physiology", "label": "Human Anatomy & Physiology" },
      { "value": "Principles_of_Training", "label": "Principles of Training" },
      { "value": "Social_Responsibility", "label": "Social Responsibility" }
    ],

    "competencies": {
      "core": [
         { "value": "Healthy_Active_Living", "label": "Healthy & Active Living" },
      { "value": "Human_Anatomy_Physiology", "label": "Human Anatomy & Physiology" },
      { "value": "Principles_of_Training", "label": "Principles of Training" },
      { "value": "Social_Responsibility", "label": "Social Responsibility" }
      ],


      "sub": {
        "physical_literacy": [
          {
            "value": "refine_apply_movement_skills_10",
            "label": "Refine and apply movement skills in a variety of physical activities and environments (10–12)"
          },
          {
            "value": "apply_movement_concepts_strategies_10",
            "label": "Apply movement concepts and strategies in different physical activities (10–12)"
          },
          {
            "value": "safety_fair_play_leadership_10",
            "label": "Develop and demonstrate safety, fair play, and leadership in physical activities (10–12)"
          },
          {
            "value": "personal_fitness_goals_10",
            "label": "Analyze and apply strategies for developing and maintaining personal fitness goals"
          },
          {
            "value": "relationship_physical_health_10",
            "label": "Explain the relationship between physical activity, health, and well-being"
          }
        ],

        "healthy_active_living": [
          {
            "value": "daily_physical_activity_10",
            "label": "Participate daily in physical activity designed to improve and maintain personal fitness and well-being"
          },
          {
            "value": "healthy_living_goals_10",
            "label": "Identify, apply, and reflect on strategies for developing healthy-living goals"
          },
          {
            "value": "factors_influencing_health_10",
            "label": "Evaluate and explain factors that influence personal health decisions"
          },
          {
            "value": "media_technology_peer_influence_10",
            "label": "Analyze influences of media, technology, and peers on health decisions"
          },
          {
            "value": "healthy_sexual_decision_making_10",
            "label": "Analyze strategies for promoting healthy sexual decision-making"
          },
          {
            "value": "healthy_relationships_10",
            "label": "Identify and apply strategies for developing and maintaining healthy relationships"
          }
        ],

        "social_community_health": [
          {
            "value": "respond_discrimination_bullying_10",
            "label": "Describe and assess strategies for responding to discrimination, stereotyping, and bullying (10–12)"
          },
          {
            "value": "promote_social_community_health_10",
            "label": "Describe strategies for promoting positive social and community health"
          },
          {
            "value": "respond_unsafe_situations_10",
            "label": "Analyze strategies for responding to unsafe situations, including potential violence and substance use"
          }
        ],

        "mental_well_being": [
          {
            "value": "manage_stress_mental_wellbeing_10",
            "label": "Apply strategies for managing stress and promoting mental well-being"
          },
          {
            "value": "manage_problems_mental_wellbeing_substance_10",
            "label": "Analyze strategies for managing problems related to mental well-being and substance use"
          },
          {
            "value": "influences_on_identity_10",
            "label": "Explain influences on identity, including sexual identity, gender, and culture"
          },
          {
            "value": "factors_influencing_mental_wellbeing_10",
            "label": "Analyze factors that influence mental well-being and decision-making"
          },
          {
            "value": "adapt_to_life_changes_10",
            "label": "Develop strategies for adapting to life changes and transitions"
          }
        ]
      }
    }
  },
    
  "phe_12_Outdoor": {
    "label": "Physical and Health Education (Outdoor Education 12)",
  "topics": [
      { "value": "Outdoor_Activity_Skills_Healthy_Living", "label": "Outdoor Activity Skills & Healthy Living" },
      { "value": "Social_Responsibility", "label": "Social Responsibility" },
      { "value": "Collaboration_Teamwork_Safety", "label": "Collaboration, Teamwork, and Safety" },
      { "value": "Outdoor_Leadership", "label": "Outdoor Leadership" }
    ],

    "competencies": {
      "core": [
           { "value": "Outdoor_Activity_Skills_Healthy_Living", "label": "Outdoor Activity Skills & Healthy Living" },
      { "value": "Social_Responsibility", "label": "Social Responsibility" },
      { "value": "Collaboration_Teamwork_Safety", "label": "Collaboration, Teamwork, and Safety" },
      { "value": "Outdoor_Leadership", "label": "Outdoor Leadership" }
      ],


      "sub": {
        "physical_literacy": [
          {
            "value": "refine_apply_movement_skills_10",
            "label": "Refine and apply movement skills in a variety of physical activities and environments (10–12)"
          },
          {
            "value": "apply_movement_concepts_strategies_10",
            "label": "Apply movement concepts and strategies in different physical activities (10–12)"
          },
          {
            "value": "safety_fair_play_leadership_10",
            "label": "Develop and demonstrate safety, fair play, and leadership in physical activities (10–12)"
          },
          {
            "value": "personal_fitness_goals_10",
            "label": "Analyze and apply strategies for developing and maintaining personal fitness goals"
          },
          {
            "value": "relationship_physical_health_10",
            "label": "Explain the relationship between physical activity, health, and well-being"
          }
        ],

        "healthy_active_living": [
          {
            "value": "daily_physical_activity_10",
            "label": "Participate daily in physical activity designed to improve and maintain personal fitness and well-being"
          },
          {
            "value": "healthy_living_goals_10",
            "label": "Identify, apply, and reflect on strategies for developing healthy-living goals"
          },
          {
            "value": "factors_influencing_health_10",
            "label": "Evaluate and explain factors that influence personal health decisions"
          },
          {
            "value": "media_technology_peer_influence_10",
            "label": "Analyze influences of media, technology, and peers on health decisions"
          },
          {
            "value": "healthy_sexual_decision_making_10",
            "label": "Analyze strategies for promoting healthy sexual decision-making"
          },
          {
            "value": "healthy_relationships_10",
            "label": "Identify and apply strategies for developing and maintaining healthy relationships"
          }
        ],

        "social_community_health": [
          {
            "value": "respond_discrimination_bullying_10",
            "label": "Describe and assess strategies for responding to discrimination, stereotyping, and bullying (10–12)"
          },
          {
            "value": "promote_social_community_health_10",
            "label": "Describe strategies for promoting positive social and community health"
          },
          {
            "value": "respond_unsafe_situations_10",
            "label": "Analyze strategies for responding to unsafe situations, including potential violence and substance use"
          }
        ],

        "mental_well_being": [
          {
            "value": "manage_stress_mental_wellbeing_10",
            "label": "Apply strategies for managing stress and promoting mental well-being"
          },
          {
            "value": "manage_problems_mental_wellbeing_substance_10",
            "label": "Analyze strategies for managing problems related to mental well-being and substance use"
          },
          {
            "value": "influences_on_identity_10",
            "label": "Explain influences on identity, including sexual identity, gender, and culture"
          },
          {
            "value": "factors_influencing_mental_wellbeing_10",
            "label": "Analyze factors that influence mental well-being and decision-making"
          },
          {
            "value": "adapt_to_life_changes_10",
            "label": "Develop strategies for adapting to life changes and transitions"
          }
        ]
      }
    }
  }
,
  science_12: {
        label: "Science (Grade 12)",
        topics: [
          { value: "biological_processes", label: "Biological Processes" },
          { value: "chemical_change", label: "Chemical Change" },
          { value: "energy_systems", label: "Energy Systems" },
          { value: "earth_systems", label: "Earth Systems" }
        ],
        competencies: {
          core: [
            { value: "questioning_predicting", label: "Questioning and Predicting" },
            { value: "planning_conducting", label: "Planning and Conducting" },
            { value: "processing_analyzing", label: "Processing and Analyzing Data and Information" },
            { value: "evaluating", label: "Evaluating" },
            { value: "applying_innovating", label: "Applying and Innovating" },
            { value: "communicating", label: "Communicating" }
          ],
          sub: {
            questioning_predicting: [
              { value: "intellectual_curiosity", label: "Demonstrate sustained intellectual curiosity about a scientific topic or problem of personal interest" },
              { value: "complex_observations_questions", label: "Make observations aimed at identifying their own increasingly complex questions about the natural world" },
              { value: "multiple_hypotheses", label: "Formulate multiple hypotheses and predict multiple outcomes" }
            ],

            planning_conducting: [
              { value: "plan_investigations", label: "Plan and use appropriate investigation methods, including field work and lab experiments" },
              { value: "assess_risks_ethics", label: "Assess risks and address ethical, cultural, and environmental issues" },
              { value: "use_equipment_accurately", label: "Select and use appropriate equipment, including digital technologies, to collect and record data accurately" },
              { value: "follow_safety_ethics", label: "Ensure that safety and ethical guidelines are followed" }
            ],

            processing_analyzing: [
              { value: "analyze_patterns_trends", label: "Seek and analyze patterns, trends, and connections in data" },
              { value: "construct_interpret_graphs", label: "Construct, analyze, and interpret graphs, models, and diagrams" },
              { value: "evaluate_methods_error", label: "Evaluate methods and experimental conditions, identifying sources of error" },
              { value: "evaluate_models_limitations", label: "Evaluate the validity and limitations of models or analogies" },
              { value: "scientific_conclusions", label: "Use knowledge of scientific concepts to draw conclusions consistent with evidence" },
              { value: "analyze_cause_effect", label: "Analyze cause-and-effect relationships" }
            ],

            evaluating: [
              { value: "identify_bias_assumptions", label: "Demonstrate awareness of assumptions, question information given, and identify bias" },
              { value: "knowledge_changes_over_time", label: "Consider changes in knowledge over time as tools and technologies have developed" },
              { value: "connect_to_science_careers", label: "Connect scientific explorations to careers in science" },
              { value: "evaluate_secondary_claims", label: "Exercise healthy, informed skepticism and evaluate claims in secondary sources" },
              { value: "social_ethical_environmental", label: "Consider social, ethical, and environmental implications" }
            ],

            applying_innovating: [
              { value: "care_self_community_world", label: "Contribute to care for self, others, community, and world through inquiry" },
              { value: "apply_learning_new_situations", label: "Transfer and apply learning to new situations" },
              { value: "generate_new_ideas", label: "Generate and introduce new ideas when problem solving" },
              { value: "solutions_local_global", label: "Contribute to finding solutions to problems at local and global levels" },
              { value: "role_of_scientists_innovation", label: "Consider the role of scientists in innovation" },
              { value: "formulate_theoretical_models", label: "Formulate theoretical models to describe a phenomenon" }
            ],

            communicating: [
              { value: "communicate_scientific_arguments", label: "Communicate scientific ideas, claims, and evidence-based arguments for specific purposes and audiences" },
              { value: "use_scientific_language", label: "Use appropriate scientific language, conventions, and representations" },
              { value: "express_reflect_worldviews", label: "Express and reflect on a variety of experiences, perspectives, and worldviews through place" }
            ]
          }
        }
      },
      core_french_12: {
        label: 'Core French',
        topics: [],
        competencies: {
          core: [
            { value: 'thinking_and_communicating', label: 'Thinking and Communicating' },
            { value: 'personal_and_social_awareness', label: 'Personal and Social Awareness' }
          ],
          sub: {
            thinking_and_communicating: [
              { value: 'explore_derive_meaning_from_texts', label: 'Explore and derive meaning from a variety of texts' },
              { value: "use_range_of_strategies", label: "Use a range of strategies to support communication" },
              { value: "seek_clarification", label: "Seek clarification of meaning" },
              { value: 'make_word_choices_to_convey_meaning', label: 'Make word choices to convey meaning' },
              { value: 'engage_in_conversations', label: 'Engage in conversations about familiar topics' },
              { value: 'express_with_increasing_fluency', label: 'Express themselves with increasing fluency, both orally and in writing' },
              { value: 'narrate_stories_orally_writing', label: 'Narrate stories, both orally and in writing' }
            ],
            personal_and_social_awareness: [
              { value: 'explore_regional_variations_in_french', label: 'Explore regional variations in French' },
              { value: 'explore_francophone_cultural_expression', label: 'Explore Francophone cultural expression' },
              { value: 'recognize_connections_language_culture', label: 'Recognize connections between language and culture' },
              { value: 'recognize_language_culture_influence', label: 'Recognize that language and culture have been influenced by the interactions of First Peoples and Francophone communities in Canada' },
              { value: 'explore_lives_contributions_francophone_canadians', label: 'Explore the lives and contributions of Francophone Canadians' },
              { value: 'explore_importance_of_story', label: 'Explore the importance of story in personal, family, and community identity' },
              { value: 'engage_in_experiences_francophone_communities', label: 'Engage in experiences with Francophone communities and people' }
            ]
          }
        }
      },
      
  
       

  "social_studies_12": {
    "label": "Social Studies (Grade 12)",
   "topics": [
      { "value": "inquiry", "label": "Inquiry" },
      { "value": "significance", "label": "Significance" },
      { "value": "evidence", "label": "Evidence" },
      { "value": "continuity_change", "label": "Continuity and Change" },
      { "value": "cause_consequence", "label": "Cause and Consequence" },
      { "value": "perspective", "label": "Perspective" },
      { "value": "ethical_judgement", "label": "Ethical Judgement" }
    ],

    "competencies": {
      "core": [
        { "value": "inquiry", "label": "Inquiry" },
        { "value": "significance", "label": "Significance" },
        { "value": "evidence", "label": "Evidence" },
        { "value": "continuity_change", "label": "Continuity and Change" },
        { "value": "cause_consequence", "label": "Cause and Consequence" },
        { "value": "perspective", "label": "Perspective" },
        { "value": "ethical_judgement", "label": "Ethical Judgement" }
      ],
         "sub": {
        "inquiry": [
          {
            "value": "inquiry_process_ss10",
            "label": "Use Social Studies inquiry processes and skills to ask questions; gather, interpret, and analyze ideas; and communicate findings and decisions"
          }
        ],

        "significance": [
          {
            "value": "assess_significance_compare_ss10",
            "label": "Assess the significance of people, places, events, or developments, and compare varying perspectives on their significance at particular times and places"
          }
        ],

        "evidence": [
          {
            "value": "assess_justification_accounts_data_ss10",
            "label": "Assess the justification for competing accounts after investigating points of contention, reliability of sources, and adequacy of evidence, including data"
          }
        ],

        "continuity_change": [
          {
            "value": "compare_contrast_continuities_ss10",
            "label": "Compare and contrast continuities and changes for different groups at particular times and places"
          }
        ],

        "cause_consequence": [
          {
            "value": "assess_conditions_actions_multiple_consequences_ss10",
            "label": "Assess how underlying conditions and the actions of individuals or groups influence events, decisions, or developments, and analyze multiple consequences"
          }
        ],

        "perspective": [
          {
            "value": "explain_infer_perspectives_ss10",
            "label": "Explain and infer different perspectives on past or present people, places, issues, or events by considering prevailing norms, values, worldviews, and beliefs"
          }
        ],

        "ethical_judgement": [
          {
            "value": "make_reasoned_ethical_judgments_ss10",
            "label": "Make reasoned ethical judgments about actions in the past and present, and assess appropriate ways to remember and respond"
          }
        ]
      }
    }
  },
 
  


    }
  }

  export default grade_12;